module.exports = __webpack_public_path__ + "img/team2.e1b6a153.png";